import {Component, EventEmitter, Input, Output} from '@angular/core';


@Component({
  selector: 'app-upload-file-list',
  templateUrl: './upload-file-list.component.html',
  styleUrls: ['./upload-file-list.component.scss']
})
export class UploadFileListComponent {


  @Input() files: any[] = [];


  @Input() removable = true;


  @Input() canRemove: (file: any) => boolean;


  @Output() removeFile = new EventEmitter<number>();


  @Output() openFile = new EventEmitter<any>();


  isRemovable(file: any): boolean {
    return this.removable && (!this.canRemove || this.canRemove(file));
  }

  isUploading(file: any): boolean {
    const progress = file?.progress;
    return progress != null && progress < 100;
  }

  readableFileSize(size: number): string {
    if (!size || size <= 0) {
      return '';
    }
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const digitGroups = Math.floor(Math.log10(size) / Math.log10(1024));
    return Math.round(size / Math.pow(1024, digitGroups)) + ' ' + units[digitGroups];
  }
}
